import {Image} from 'components/common/Image'
import {Frame} from 'components/system/Frame'
import {Ventrata} from 'types'

type Props = {
  option: Ventrata.Option
}

export const TourCard = ({option}: Props) => {
  return (
    <Frame className="flex gap-4 p-4">
      <Image src={option.coverImageUrl} title={option.title} />
      <div className="text-lg font-bold">{option.title}</div>
    </Frame>
  )
}
